import 'imports-loader?this=>window!jquery.browser';
import './others/truly-visibility';
import './others/a3320_tracking';
import 'imports-loader?this=>window!./others/jquery.appear';
import 'imports-loader?this=>window!./others/jquery.splendid.textchange';

import './others/cloud-zoom';
import './others/emstrack';

import './home24-shared/layout/address-form/normalize-nl-zip-code-plugin';

import './home24/helpers/custom-elements';
import './home24/helpers/refresher';
import './home24/helpers/doubleclick';
import { exportLightBoxToWindow } from './home24/helpers/lightbox';
import { exportValidationToWindow } from './home24-desktop/validation/validation-controller';
import AdBlock from './home24-desktop/helpers/adblock';
import './home24/core/touch';
import './home24-desktop/rivets/config';
import './home24-desktop/rivets/binders';
import './home24-desktop/rivets/formatters';
import './home24-desktop/rivets/ieFix';
import { run } from './home24-desktop/core/bootstrapper';
import './home24/helpers/section-slider';
import './home24/modules/common/cms-image-slider';
import './home24/modules/common/data-tipped';
import './home24/modules/common/marketplace';
import './home24-desktop/sliders/slidersBootstrap';
import './home24-shared/wishlist/wishlistService';
import './home24-desktop/components/collapsible/collapsibleBootstrap';

import './home24-desktop/layout/layoutBootstrap';
import './home24-desktop/layout/header/headerBootstrap';
import './home24-desktop/layout/searchField/searchFieldBootstrap';
import './home24-desktop/layout/wishlist/wishlistBootstrap';
import './home24-desktop/layout/categoryList';
import './home24-desktop/layout/contactFormMessage';
import './home24-desktop/layout/helpareaBadge';
import './home24-desktop/layout/redirectedTrafficView';
import './home24-desktop/layout/shopTheLook';
import './home24-desktop/layout/teaserBootstrap';
import './home24-desktop/layout/deliveryTimes';
import './home24-desktop/layout/consoleBranding';

import './home24-desktop/pages/cart/cartBootstrap';
import './home24-desktop/pages/catalog/catalogNewBootstrap';
import './home24-desktop/pages/checkout/checkoutBootstrap';
import './home24-desktop/pages/cms/cmsBootstrap';
import './home24-desktop/pages/fttc1/fttc1Bootstrap';
import './home24-desktop/pages/fttc2/fttc2Bootstrap';
import './home24-desktop/pages/login/loginBootstrap';
import './home24-desktop/pages/myAccount/myAccountBootstrap';
import './home24-desktop/pages/pdp-new/pdpNewBootstrap';
import './home24-desktop/tracking/myAccount/trackingBootstrap';
import './home24-desktop/tracking/cart/trackingBootstrap';
import './home24-desktop/tracking/catalog/trackingBootstrap';
import './home24-desktop/tracking/checkout/trackingBootstrap';
import './home24-desktop/tracking/common/trackingBootstrap';
import './home24-desktop/tracking/layout/trackingBootstrap';
import './home24-desktop/tracking/login/trackingBootstrap';
import './home24-desktop/tracking/wishlist/trackingBootstrap';
import './home24-desktop/tracking/factfinder';

import { init as initSmartBanner } from './home24-shared/home24.smartBanner';
import { bindListenersToSlidingMenu } from './home24-shared/home24.slidingMenu';
import { start as startStickyOverview } from './home24-shared/layout/sticky-overview';

initSmartBanner();
bindListenersToSlidingMenu();
exportLightBoxToWindow();
exportValidationToWindow();
new AdBlock();
startStickyOverview();

run();



/** WEBPACK FOOTER **
 ** ./legacy/desktop-app.js
 **/